import { combineReducers } from "@reduxjs/toolkit";

//reducers
import authReducer from "./auth/reducer";
import userReducer from "./user/reducer";
import settingReducer from "./settings/reducer";
import coinReducers from "./coinList/reducer";
import languageReducer from "./language/reducer";
import gameReducer from "./game/reducer";
import tasksReducer from "./tasks/reducer";
import roadmapReducer from "./roadmaps/reducer";
import energyPackageReducer from "./energyPackages/reducer";
import jackpotReducer from "./jackpot/reducer";
import historicalReducer from "./HistoricalData/reducer";

const rootReducer = combineReducers({
  Auth: authReducer,
  Users: userReducer,
  Settings: settingReducer,
  CoinList: coinReducers,
  Language: languageReducer,
  Game: gameReducer,
  Tasks: tasksReducer,
  Roadmaps: roadmapReducer,
  EnergyPackage: energyPackageReducer,
  Jackpot: jackpotReducer,
  HistoricalData: historicalReducer,
});

export default rootReducer;
